import './formDetalle.scss';
import { useState, useEffect, useContext } from "react";
import { ClientesZonasFormContext } from '../../../../../context/clienteszonas/ClientesZonasContext';
import ClientesModal from '../../../../clientes/clientesModal/clientesModal';
import ErrorDialog from "../../../../../components/dialogs/ErrorDialog";
import { getClienteById } from '../../../../../services/ClientesServices';

export const FormDetalle = ({
  zonaId,
  iddet,
  addItem,
  getItem,
  updateItem,
  arrayDetalle,
  closeModal
}) => {

  const {
    report,
    getClienteZonaByIdData,
    asignarZonasPorGpsData,
  } = useContext(ClientesZonasFormContext);

  const [title, setTitle] = useState('');
  const [form, setForm] = useState({
    es_principal: 1,
    asignacion: 'manual',
  });
  const [errors, setErrors] = useState({});

  // Estados para cliente
  const [searchIdCliente, setSearchIdCliente] = useState();
  const [searchDescCliente, setSearchDescCliente] = useState('');

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [estadoForm, setEstadoForm] = useState(0); // 0 = nuevo, 1 = editando

  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // ═══════════════════════════════════════════════════════════════════════════
  // Título dinámico
  // ═══════════════════════════════════════════════════════════════════════════
  useEffect(() => {
    iddet ? setTitle('Editar Asignación') : setTitle('Agregar Cliente a Zona');
  }, [iddet]);

  // ═══════════════════════════════════════════════════════════════════════════
  // Cargar datos al editar
  // ═══════════════════════════════════════════════════════════════════════════
  useEffect(() => {
    const fetchData = async () => {
      if (iddet) {
        // Buscar en el array local
        const detalleEnArray = arrayDetalle.find((item) => item.id === iddet);

        if (detalleEnArray) {
          setForm({
            ...detalleEnArray,
            es_principal: detalleEnArray.es_principal ?? 1,
            asignacion: detalleEnArray.asignacion ?? 'manual',
          });
          setSearchIdCliente(detalleEnArray.user_id);
          setSearchDescCliente(detalleEnArray.cliente?.cli_name || detalleEnArray.cli_name || "");
          setEstadoForm(1);

        } else {
          // Buscar en la API
          try {
            const detalle = await getClienteZonaByIdData(iddet);
            if (detalle) {
              setForm({
                ...detalle,
                es_principal: detalle.es_principal ?? 1,
                asignacion: detalle.asignacion ?? 'manual',
              });
              setSearchIdCliente(detalle.user_id);
              setSearchDescCliente(detalle.cliente?.cli_name || "");
              setEstadoForm(1);
            }
          } catch (error) {
            console.error("Error al obtener datos:", error);
          }
        }
      }
    };

    fetchData();
  }, [zonaId, iddet]);

 useEffect(() => {
  const fetchCliente = async () => {
    if (searchIdCliente) {
      const cliente = await getClienteById(searchIdCliente);  
      if (cliente) {
        setForm((prev) => ({
          ...prev,
          user_id: cliente.id,  // ← Agregá esto también
          cli_name: cliente.cli_name,
          razon_social: cliente.razon_social,
          cli_gps_latitud: cliente.cli_gps_latitud,
          cli_gps_longitud: cliente.cli_gps_longitud,
        }));
      }
    }
  };

  fetchCliente();
}, [searchIdCliente]);



  // ═══════════════════════════════════════════════════════════════════════════
  // Cambio de inputs
  // ═══════════════════════════════════════════════════════════════════════════
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // ═══════════════════════════════════════════════════════════════════════════
  // Validación
  // ═══════════════════════════════════════════════════════════════════════════
  const validateForm = () => {
    let formErrors = {};

    if (!form.user_id) {
      formErrors.user_id = "Debe seleccionar un cliente.";
    }

    // Verificar si ya existe en el array
    const existe = arrayDetalle.find(
      (item) => item.user_id === form.user_id && item.id !== iddet
    );
    if (existe) {
      formErrors.user_id = "Este cliente ya está asignado a la zona.";
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  // ═══════════════════════════════════════════════════════════════════════════
  // Enviar datos
  // ═══════════════════════════════════════════════════════════════════════════
  const handleSendData = () => {
    if (!validateForm()) {
      const errorMessages = Object.values(errors).filter(Boolean);
      if (errorMessages.length > 0) {
        setErrorMessage(errorMessages);
        setIsErrorDialogOpen(true);
      }
      return;
    }

    const newForm = {
      user_id: form.user_id,
      zona_id: Number(zonaId),
      es_principal: Number(form.es_principal),
      asignacion: form.asignacion,
      distancia_km: form.distancia_km || null,
      // Para mostrar en la grilla
      cliente: {
        id: form.user_id,
        cli_name: form.cli_name || searchDescCliente,
        razon_social: form.cli_razon_social || "",
      },
      cli_name: form.cli_name || searchDescCliente,
      id: iddet || `temp_${Date.now()}`,
      isNew: !iddet,
    };

    if (iddet) {
      updateItem(iddet, newForm);
    } else {
      addItem(newForm);
    }

    closeModal();
  };

  const handleCancel = () => {
    closeModal();
  };

  const closeErrorDialog = () => setIsErrorDialogOpen(false);

  // Función para generar ID temporal
  const generateRandomId = () => `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

  return (
    <>
      <div className="formDetalle">
        <div className="formDetalle__header">
          <h2 className="formDetalle__title">{title}</h2>
        </div>

        <div className="formDetalle__body">

          {/* SECCIÓN: CLIENTE */}
          <div className="formDetalle__section formDetalle__section--article">
            <div className="formDetalle__section-title">
              <span className="formDetalle__section-icon">👤</span>
              Cliente
            </div>
            <div className="formDetalle__section-content formDetalle__section-content--2cols">

              {/* Buscador de cliente (solo en modo nuevo) */}
              {estadoForm === 0 && (
                <div className="formDetalle__field formDetalle__field--full">
                  <label>Buscar Cliente *</label>
                  <ClientesModal
                    handleChange={setSearchIdCliente}
                    handleDescChange={setSearchDescCliente}
                    descSelected={searchDescCliente}
                  />
                  {errors.user_id && <span className="formDetalle__error">{errors.user_id}</span>}
                </div>
              )}

              {/* Nombre del cliente (readonly cuando edita) */}
              <div className="formDetalle__field">
                <label>Nombre</label>
                <input
                  type="text"
                  value={form.cli_name || searchDescCliente || ''}
                  className="formDetalle__input formDetalle__input--readonly"
                  readOnly
                />
              </div>

              {/* Razón Social */}
              <div className="formDetalle__field">
                <label>Razón Social</label>
                <input
                  type="text"
                  value={form.razon_social || ''}
                  className="formDetalle__input formDetalle__input--readonly"
                  readOnly
                />
              </div>
            </div>
          </div>

          {/* SECCIÓN: CONFIGURACIÓN */}
          <div className="formDetalle__section formDetalle__section--config">
            <div className="formDetalle__section-title">
              <span className="formDetalle__section-icon">⚙️</span>
              Configuración
            </div>
            <div className="formDetalle__section-content formDetalle__section-content--3cols">

              <div className="formDetalle__field">
                <label>Zona Principal</label>
                <select
                  name="es_principal"
                  value={form.es_principal ?? 1}
                  className="formDetalle__select"
                  onChange={handleInputChange}
                >
                  <option value={1}>Sí (Principal)</option>
                  <option value={0}>No (Secundaria)</option>
                </select>
              </div>

              <div className="formDetalle__field">
                <label>Tipo de Asignación</label>
                <select
                  name="asignacion"
                  value={form.asignacion || 'manual'}
                  className="formDetalle__select"
                  onChange={handleInputChange}
                >
                  <option value="manual">Manual</option>
                  <option value="auto">Automática (GPS)</option>
                </select>
              </div>

              <div className="formDetalle__field">
                <label>Distancia (km)</label>
                <input
                  type="number"
                  name="distancia_km"
                  value={form.distancia_km ?? ''}
                  className="formDetalle__input formDetalle__input--readonly"
                  readOnly
                  placeholder="Se calcula automáticamente"
                />
              </div>
            </div>
          </div>

          {/* BOTONES */}
          <div className="formDetalle__actions">
            <button
              type="button"
              className="formDetalle__btn formDetalle__btn--primary"
              onClick={handleSendData}
              disabled={isSubmitting}
            >
              {isSubmitting ? '⏳ Guardando...' : '✓ Asignar Cliente'}
            </button>
            <button
              type="button"
              className="formDetalle__btn formDetalle__btn--secondary"
              onClick={handleCancel}
              disabled={isSubmitting}
            >
              ✕ Cancelar
            </button>
          </div>
        </div>
      </div>

      <ErrorDialog
        isOpen={isErrorDialogOpen}
        onClose={closeErrorDialog}
        messages={errorMessage}
        title=""
      />
    </>
  );
};

export default FormDetalle;
